module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-right/arrow-right-light-0e8619b4d196127f7dfffbc88b9851eb.svg";